var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Formatter, TableType, UiFramework, } from "../definition/context-types";
import { AppContext } from "../generation/context/app-context";
import { PageContext } from "../generation/context/page-context";
import { WidgetContext } from "../generation/context/widget-context";
import MuiDataTableGenerator from "../generation/generators/list/mui-datatable-generator";
import MuiDetailGenerator from "../generation/generators/detail/mui-detail-generator";
import GrommetDataTableGenerator from "../generation/generators/list/grommet-dt-generator";
import { BasicTableGenerator } from "../generation/generators/list/basic-table-generator";
import { generateNewRoute } from "../generation/generators/routes/route-generator";
import { addMenuItem } from "../generation/generators/menu/menu-generator";
export function insertColumn(tablePosition, options, io) {
    return __awaiter(this, void 0, void 0, function () {
        var generationContext, appContext, sourceFileContext, widgetContext, generator;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    generationContext = {
                        uiFramework: UiFramework.MaterialUI,
                        formatter: Formatter.None,
                        index: { tableType: TableType.DataTable, height: "400px" },
                    };
                    appContext = new AppContext(generationContext, io);
                    sourceFileContext = new PageContext(appContext, tablePosition.fileName);
                    widgetContext = new WidgetContext(sourceFileContext);
                    generator = new MuiDataTableGenerator(generationContext, undefined, widgetContext);
                    return [4 /*yield*/, generator.insertColumn(tablePosition, options.entityField, options.index)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function deleteColumn(tablePosition, options, io) {
    return __awaiter(this, void 0, void 0, function () {
        var generationContext, appContext, sourceFileContext, widgetContext, generator;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    generationContext = {
                        uiFramework: UiFramework.MaterialUI,
                        formatter: Formatter.None,
                        index: { tableType: TableType.DataTable, height: "400px" },
                    };
                    appContext = new AppContext(generationContext, io);
                    sourceFileContext = new PageContext(appContext, tablePosition.fileName);
                    widgetContext = new WidgetContext(sourceFileContext);
                    generator = new MuiDataTableGenerator(generationContext, undefined, widgetContext);
                    return [4 /*yield*/, generator.deleteColumn(tablePosition, options.index)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function insertColumnToDataTableGrommet(tablePosition, options, io) {
    return __awaiter(this, void 0, void 0, function () {
        var generationContext, appContext, sourceFileContext, widgetContext, generator;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    generationContext = {
                        uiFramework: UiFramework.Grommet,
                        formatter: Formatter.None,
                        index: { tableType: TableType.DataTable, height: "400px" },
                    };
                    appContext = new AppContext(generationContext, io);
                    sourceFileContext = new PageContext(appContext, tablePosition.fileName);
                    widgetContext = new WidgetContext(sourceFileContext);
                    generator = new GrommetDataTableGenerator(generationContext, undefined, widgetContext);
                    return [4 /*yield*/, generator.insertColumn(tablePosition, options.entityField, options.index)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function insertColumnToBasicTableMui(tablePosition, options, io) {
    return __awaiter(this, void 0, void 0, function () {
        var generationContext, appContext, sourceFileContext, widgetContext, generator;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    generationContext = {
                        uiFramework: UiFramework.MaterialUI,
                        formatter: Formatter.None,
                        index: { tableType: TableType.BasicTable, height: "400px" },
                    };
                    appContext = new AppContext(generationContext, io);
                    sourceFileContext = new PageContext(appContext, tablePosition.fileName);
                    widgetContext = new WidgetContext(sourceFileContext);
                    generator = new BasicTableGenerator(generationContext, options.entity, widgetContext);
                    return [4 /*yield*/, generator.insertColumn(tablePosition, options.entityField, options.index)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function insertColumnToBasicTableGrommet(tablePosition, options, io) {
    return __awaiter(this, void 0, void 0, function () {
        var generationContext, appContext, sourceFileContext, widgetContext, generator;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    generationContext = {
                        uiFramework: UiFramework.Grommet,
                        formatter: Formatter.None,
                        index: { tableType: TableType.BasicTable, height: "400px" },
                    };
                    appContext = new AppContext(generationContext, io);
                    sourceFileContext = new PageContext(appContext, tablePosition.fileName);
                    widgetContext = new WidgetContext(sourceFileContext);
                    generator = new BasicTableGenerator(generationContext, options.entity, widgetContext);
                    return [4 /*yield*/, generator.insertColumn(tablePosition, options.entityField, options.index)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function insertFormWidget(formPosition, options, io) {
    return __awaiter(this, void 0, void 0, function () {
        var generationContext, appContext, sourceFileContext, widgetContext, generator;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    generationContext = {
                        uiFramework: UiFramework.MaterialUI,
                        formatter: Formatter.None,
                        index: { tableType: TableType.DataTable, height: "400px" },
                    };
                    appContext = new AppContext(generationContext, io);
                    sourceFileContext = new PageContext(appContext, formPosition.fileName);
                    widgetContext = new WidgetContext(sourceFileContext);
                    generator = new MuiDetailGenerator(generationContext, options.entity, widgetContext);
                    return [4 /*yield*/, generator.insertFormWidget(formPosition, options.entityField, options.index)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function getColumnSourcePosition(tablePosition, options, io) {
    return __awaiter(this, void 0, void 0, function () {
        var generationContext, appContext, sourceFileContext, widgetContext, generator;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    generationContext = {
                        uiFramework: UiFramework.MaterialUI,
                        formatter: Formatter.None,
                        index: { tableType: TableType.DataTable, height: "400px" },
                    };
                    appContext = new AppContext(generationContext, io);
                    sourceFileContext = new PageContext(appContext, tablePosition.fileName);
                    widgetContext = new WidgetContext(sourceFileContext);
                    generator = new MuiDataTableGenerator(generationContext, undefined, widgetContext);
                    return [4 /*yield*/, generator.getColumnSourcePosition(tablePosition, options.index)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function getFormWidgetProperties(position, io) {
    return __awaiter(this, void 0, void 0, function () {
        var generationContext, appContext, sourceFileContext, widgetContext, generator;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    generationContext = {
                        uiFramework: UiFramework.MaterialUI,
                        formatter: Formatter.None,
                        index: { tableType: TableType.DataTable, height: "400px" },
                    };
                    appContext = new AppContext(generationContext, io);
                    sourceFileContext = new PageContext(appContext, position.fileName);
                    widgetContext = new WidgetContext(sourceFileContext);
                    generator = new MuiDetailGenerator(generationContext, undefined, widgetContext);
                    return [4 /*yield*/, generator.getFormWidgetProperties(position)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function setFormWidgetProperties(position, io, properties) {
    return __awaiter(this, void 0, void 0, function () {
        var generationContext, appContext, sourceFileContext, widgetContext, generator;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    generationContext = {
                        uiFramework: UiFramework.MaterialUI,
                        formatter: Formatter.None,
                        index: { tableType: TableType.DataTable, height: "400px" },
                    };
                    appContext = new AppContext(generationContext, io);
                    sourceFileContext = new PageContext(appContext, position.fileName);
                    widgetContext = new WidgetContext(sourceFileContext);
                    generator = new MuiDetailGenerator(generationContext, undefined, widgetContext);
                    return [4 /*yield*/, generator.setFormWidgetProperties(position, properties)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function generateRoute(options, io) {
    return __awaiter(this, void 0, void 0, function () {
        var routesDefinitionSource;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, io.readFile(options.routeFilePath)];
                case 1:
                    routesDefinitionSource = _a.sent();
                    if (routesDefinitionSource) {
                        return [2 /*return*/, generateNewRoute(routesDefinitionSource, options.componentRouteUri, options.componentName, options.componentFilePath)];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function generateMenuItem(options, io) {
    return __awaiter(this, void 0, void 0, function () {
        var menuDefinitionSource;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, io.readFile(options.menuDefinitionFilePath)];
                case 1:
                    menuDefinitionSource = _a.sent();
                    if (menuDefinitionSource) {
                        return [2 /*return*/, addMenuItem(menuDefinitionSource, options.itemTitle, options.itemUri, options.itemIcon)];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
